import { Link } from "react-router-dom";
import { useState } from "react";
import { MapPin, Send } from "lucide-react";
import { km } from "@/lib/api";
import { featuredPrice, PriceTag } from "@/lib/prices";
import { useServiceMap } from "@/lib/data";
import { ServiceIcon } from "@/lib/icons";
import { Avatar, Rating } from "@/components/Bits";

function Prices({ p }) {
  const [all, setAll] = useState(false);
  const main = featuredPrice(p);
  if (!main) return null;
  const off = Number(p.discount_pct) || 0;
  const rest = p.prices.filter((x) => x !== main);
  return (
    <div className="mt-2 text-lg" data-testid={`provider-prices-${p.id}`}>
      <PriceTag item={main} off={off} />
      {rest.length > 0 && !all && (
        <button type="button" onClick={() => setAll(true)} className="ml-1 block text-sm text-slate-500 underline" data-testid={`provider-prices-all-${p.id}`}>ver todos os preços</button>
      )}
      {all && rest.map((x, i) => <PriceTag key={i} item={x} off={off} className="mt-1 block text-base" />)}
    </div>
  );
}

export default function ProviderCard({ p, serviceSlug }) {
  const services = useServiceMap();
  return (
    <div className="po-card po-rise" data-testid={`provider-card-${p.id}`}>
      <div className="flex gap-4">
        <Avatar photo={p.photo} name={p.name} />
        <div className="min-w-0 flex-1">
          <div className="flex items-start justify-between gap-2">
            <Link to={`/prestador/${p.id}`} className="font-display text-xl font-bold text-slate-900 hover:text-orange-600" data-testid={`provider-name-${p.id}`}>
              {p.name}
            </Link>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-orange-500 text-white">
              <ServiceIcon icon={services[p.primary_service]?.icon} className="h-5 w-5" />
            </span>
          </div>
          <div className="mt-1 flex flex-wrap items-center gap-3">
            <Rating avg={p.rating_avg} count={p.rating_count} />
            <span className="inline-flex items-center gap-1 text-base font-semibold text-orange-700" data-testid={`provider-distance-${p.id}`}>
              <MapPin className="h-5 w-5" /> {km(p.distance_km)} de você
            </span>
          </div>
          {p.discount_pct > 0 && (
            <span className="mt-2 inline-flex rounded-full bg-green-600 px-3 py-1 text-base font-extrabold text-white" data-testid={`provider-discount-${p.id}`}>
              {p.discount_pct}% OFF no orçamento
            </span>
          )}
          <Prices p={p} />
          <p className="mt-1 text-base text-slate-600">Região: {p.base_neighborhood}, {p.base_city}</p>
        </div>
      </div>
      {p.description && <p className="mt-3 text-base text-slate-700">{p.description}</p>}
      <div className="mt-4 flex flex-wrap gap-2">
        <Link to={`/pedido/novo?servico=${serviceSlug}&prestador=${p.id}`} className="po-btn-primary flex-1" data-testid={`provider-request-${p.id}`}>
          <Send className="h-5 w-5" /> Pedir orçamento
        </Link>
        <Link to={`/prestador/${p.id}`} className="po-btn-outline" data-testid={`provider-profile-${p.id}`}>Ver perfil</Link>
      </div>
    </div>
  );
}
